import React, { Component } from "react";
import * as Const from "../Constant";
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Checkbox from '@mui/material/Checkbox';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CardHeader from '@mui/material/CardHeader';
import ChoixSelection from "./ChoixSelection";
import ChoixCondition from "./ChoixCondition";
import Divider from '@mui/material/Divider';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PanelResultat from "./PanelResultat";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import Drawer from '@mui/material/Drawer';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import TableauPronostics from "./TableauPronostics";
import FiltrePronostics from "./FiltrePronostics";
import DialogResultat from "./DialogResultat";
import Tooltip from '@mui/material/Tooltip';
import DialogOnboardSyntheseMax from "./DialogOnboardSyntheseMax";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import AlertTitle from '@mui/material/AlertTitle';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import FullscreenExitOutlinedIcon from '@mui/icons-material/FullscreenExitOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import FiltrePronosticsSynthese from './FiltrePronosticsSynthese'
import TableauPronosticsSynthese from "./TableauPronosticsSynthese";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Badge from '@mui/material/Badge';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import fileDownload from 'js-file-download'
import axios from 'axios'
import DialogAide from './DialogAide'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';


export default class SyntheseMax extends Component {

    constructor(props) {
        super(props);
        this.state = {
          pronostics: null,
          loader: false,
          openDialog: false,
          result:null,
          zoom: false,
          taillePanelFiltre: "22vw",
          taillePanel: "78vw",
          openMenu:false,
          anchor:null,
          consensus:"large",
          openDialogEnregistrer: false,
          bilan: null,
          openPoint: false,
          point: "1",
          aideConsensus:false
        }

        this.selection = "";
        this.label = "";
        this.actif = "";
        this.dossier = "Bases";
        this.pronoJour = false;
        this.pronoSelected = null;
    }

    select = (id) => {
      this.setState({loader: true});
      fetch(
        Const.URL_WS_METHODE_EXEC + `?utilisateur=${localStorage.getItem("utilisateur_dtf")}&methodeID=${id}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.setState({loader: false});
          this.setState({result: data});
          this.setState({openDialog: true});
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
        });
    }

    componentWillReceiveProps(props) {        
    }

    componentDidMount() {
      this.auth();
      this.findByDossier();
    }

    openAideConsensus = () => {
      this.setState({ aideConsensus: true});
    }

    redirectForum = () => {
      window.open("https://dataturf.flarum.cloud/", "_blank", "noopener,noreferrer");
    }
    
    closeAideConsensus = () => {
      this.setState({ aideConsensus: false});
    }

    redirectTableau = () => {
      window.location.href = Const.URL;
    }

    handleSelectPoint = (event) => {
      this.setState({ point: event.target.value});
    }

    resize = () => {
      if(this.state.zoom){
        this.setState({zoom: false});
        this.setState({taillePanelFiltre: '22vw'});
        this.setState({taillePanel: '78vw'});
      }else{
        this.setState({taillePanelFiltre: '0vw'});
        this.setState({taillePanel: '100vw'});
        this.setState({zoom: true});
      } 
    }

    auth = () => {
      let user = localStorage.getItem("utilisateur_dtf");
      let pass = localStorage.getItem("pass_dtf");
      fetch(
        Const.URL_WS_AUTH + `?email=${user}&password=${pass}&ipClient=`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
         
          if(!data.register || data.expiration){
            window.location.href = Const.URL + "synthese";
          }
          else{
            this.setState({syntheseMax: data.moduleSyntheseMax});
            this.callPronostics();
          }
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
        });
    }

    closeDialog = () => {
      this.setState({openDialog: false});
    }

    updatePoint = (id, point) => {
      this.setState({openPoint: true});
      this.pronoSelected = id;
    }

    deletePronostics = (id) => {
      fetch(
        Const.URL_WS_METHODE_DELETE + `?utilisateur=${localStorage.getItem("utilisateur_dtf")}&id=${id}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.callPronostics();
        })
        .catch((error) => {
          console.log("Request failed", error);
        });
    }

    updateActif = (id) => {
      fetch(
        Const.URL_WS_METHODE_ACTIF + `?id=${id}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.callPronostics();
        })
        .catch((error) => {
          console.log("Request failed", error);
        });
    }

    updateObligatoire = (id) => {
      fetch(
        Const.URL_WS_METHODE_OBLIGATOIRE + `?id=${id}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.callPronostics();
        })
        .catch((error) => {
          console.log("Request failed", error);
        });
    }

    callPronostics = () => {
      this.setState({loader: true});
      fetch(
        Const.URL_WS_METHODE_PRONOSTICS + `?utilisateur=${localStorage.getItem("utilisateur_dtf")}&dossier=${this.dossier}&label=${this.label}
        &selection=${this.selection}
        &dynamique=${this.dynamique}
        &reussiteGagnant=${this.reussiteGagnant}
        &reussitePlace=${this.reussitePlace}
        &pronoJour=${this.pronoJour}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.setState({pronostics:data.pronostics});
          this.setState({loader: false});
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
        });
    }

    redirectPronostics = () => {
      window.location.href = Const.URL + "pronostics";
    }

    redirectEditeur = () => {
      window.location.href = Const.URL + "editeur";
    }

    closeOpenPoint = () => {
      this.setState({openPoint: false});
    }

    closeDialogEnregistrer = () => {
      this.setState({openDialogEnregistrer: false});
    }

    findByDossier = () => {
      this.setState({ loader: true})
      let user = localStorage.getItem("utilisateur_dtf");
      fetch(
        Const.URL_WS_SYNTHESE_MAX_DOSSIER + `?utilisateur=${user}&dossier=${this.dossier}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.setState({loader: false});
          this.setState({consensus: data.consensus});
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
        });
    }

    savePoint = () => {

      this.setState({ loader: true})
      let user = localStorage.getItem("utilisateur_dtf");
      fetch(
        Const.URL_WS_METHODE_POINT + `?id=${this.pronoSelected}&point=${this.state.point}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.setState({loader: false});
          this.setState({openPoint: false});
          this.callPronostics();
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
          this.setState({openPoint: false});
        });

      
    }

    save = () => {
      this.setState({ loader: true})
      let user = localStorage.getItem("utilisateur_dtf");
      fetch(
        Const.URL_WS_SYNTHESE_MAX_SAVE + `?utilisateur=${user}&dossier=${this.dossier}&consensus=${this.state.consensus}`,
        { retry: 0, retryDelay: 1000 }
      )
        .then((res) => res.json())
        .then((data) => {
          this.setState({loader: false});
          this.setState({openDialogEnregistrer: false});
        })
        .catch((error) => {
          console.log("Request failed", error);
          this.setState({loader: false});
        });
    }


    handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
      this.setState({anchor: event.currentTarget});
      this.setState({openMenu: true});      
    }

    redirectTableau = () => {
      window.location.href = Const.URL;
    }

    handleCloseMenu = () => {
      this.setState({openMenu: false});
    }

    handleConsensus = (event) => {
      this.setState({consensus: event.target.value});
    }
    
    redirectBibliotheque = () => {
      window.location.href = Const.URL + "algoProno";
    }
    redirectHome = () => {
      window.location.href = Const.URL + "synthese";
    }

    redirectEditeur = () => {
      window.location.href = Const.URL + "editeur";
    }

    openDialogEnregistrer = () => {
      this.setState({openDialogEnregistrer: true});
    }

    activeAide =() => {
      localStorage.setItem("onboardSyntheseMax", 0);
      window.location.href = Const.URL + "syntheseMax";
    }

    filtres = (dossier) => {
      this.dossier = dossier;
      this.findByDossier(); 
      this.callPronostics();
    }

   

     handleDownload = (url, filename) => {
        this.setState({ showModule: false})
        this.setState({ loader: true})
        axios.get(Const.URL_WS_EXPORT_SYNTHESE_MAX + `?utilisateur=${localStorage.getItem("utilisateur_dtf")}&dossier=${this.dossier}&consensus=${this.state.consensus}`, {
          responseType: 'blob',
        })
        .then((res) => {
          this.setState({ loader: false})
          fileDownload(res.data, filename)
        })
      }

    runTest = () => {
      this.setState({loader: true});
              let user = localStorage.getItem("utilisateur_dtf");
              fetch(
                Const.URL_WS_SYNTHESE_MAX + `?utilisateur=${user}&dossier=${this.dossier}&consensus=${this.state.consensus}&export=false`,
                { retry: 0, retryDelay: 1000 }
              )
                .then((res) => res.json())
                .then((data) => {
                  this.setState({bilan: data});
                  this.setState({loader: false});
                })
                .catch((error) => {
                  console.log("Request failed", error);
                  this.setState({loader: false});
                });
    }

   
    render() {

      function consu(data){
       if(data == "large"){
          return(
            <span class="lato-regular-italic"><b>Mode Large</b></span>
          )
        }
        if(data == "equilibre"){
          return(
            <span class="lato-regular-italic"><b>Mode Équilibré</b></span>
          )
        }
        if(data == "majoritaire"){
          return(
            <span class="lato-regular-italic"><b>Mode Majoritaire</b></span>
          )
        }
        if(data == "strict"){
          return(
            <span class="lato-regular-italic"><b>Mode Strict</b></span>
          )
        }
      }

      function syn(data){
        if(data == "Bases"){
          return(
            <span class="lato-regular-italic"><b>Synthèse personnalisée</b></span>
          )
        }
        if(data == "Archive"){
          return(
            <span class="lato-regular-italic"><b>Synthèse personnalisée - Archive</b></span>
          )
        }

        if(data == "Test"){
          return(
            <span class="lato-regular-italic"><b>Synthèse personnalisée - Test</b></span>
          )
        }
      }

        function selection(data){
            return(
            <div align="center">
            <Avatar style={{backgroundColor:"#3f51b5", width:"50px", height:"20px", marginTop:"0.4em", align:"right"}} variant="square">
              <span class="lato-regular" style={{ fontSize:"14px", color:"white"}}>{format(data)}</span>
            </Avatar>
            </div>
            )
        }

        function format(data){
          data = Number(data);
          return data.toLocaleString('fr-FR');
        }


        function color(num, syn1, syn2, syn3, syn4, syn5){
          if(num == syn1){
            return "#66B230"
          }
    
          if(num == syn2){
            return "#FF8F60"
          }
    
          if(num == syn3){
            return "#FFAA16"
          }
    
          if(num == syn4){
            return "#5B86F2"
          }
    
          if(num == syn5){
            return "#B491FF"
          }
          
          
          return "";
        }

 function reussite(data){
      var color = "";

        if(data < 0){
          data = "-";
        }else if(data > 75){
          color = "#2D7E43";
        }else if(data > 50 && data <= 75){
          color = "#97BA38";
        }else if(data >= 25 && data <= 50){
          color = "#E8B610";
        }else if(data > 10 && data <= 25){
          color = "#D57B1A";
        }else if(data >= 0 && data <= 10){
          color = "#C53419";
        }

        return  (
          <Avatar style={{backgroundColor:color, width:"50px", height:"20px"}} variant="square">
            <span class="lato-regular" style={{ fontSize:"14px", color:"white"}}>{data} %</span>
          </Avatar>
        )
      
    }

        return (
            <div>

              {(localStorage.getItem("onboardSyntheseMax") == null || localStorage.getItem("onboardSyntheseMax") == 0) && (
                <DialogOnboardSyntheseMax titre={"onboardSyntheseMax"} open={true} cookie={"onboardSyntheseMax"}/>
              )}


              {this.state.aideConsensus && (
                  <DialogAide titre={"Astuce"} open={true} 
                  close={this.closeAideConsensus}
                  content={

  <div>
  <p><span class="lato-bold">ℹ️ Aide : Choix du Mode de Consensus</span></p>
  <p><span class="lato-regular">Le </span><span class="lato-bold">mode de consensus</span><span class="lato-regular"> détermine comment les pronostics sélectionnés sont fusionnés pour créer la </span><span class="lato-bold">synthèse finale</span><span class="lato-regular">. Il influence le </span><span class="lato-bold">nombre de chevaux retenus</span><span class="lato-regular"> et leur </span><span class="lato-bold">classement</span><span class="lato-regular">, selon leur présence et leur score dans les différents pronostics.</span></p>

  <p><span class="lato-bold">🟢 Mode Strict</span></p>
  <p><span class="lato-regular">Seuls les chevaux présents dans </span><span class="lato-bold">tous les pronostics</span><span class="lato-regular"> de la synthèse sont retenus.<br/>
 <br/>👉 Ce mode repose sur un </span><span class="lato-bold">consensus total</span><span class="lato-regular">, ne conservant que les chevaux sur lesquels </span><span class="lato-bold">tout le monde est d'accord</span><span class="lato-regular">.<br/>
  <br/><span class="lato-bold">Résultat :</span> Une sélection très ciblée, parfaite pour des jeux courts et sûrs.</span></p>

  <p><span class="lato-bold">🟡 Mode Équilibré</span></p>
  <p><span class="lato-regular">Les chevaux fréquemment cités sont favorisés, mais ceux présents dans un seul pronostic peuvent aussi apparaître s’ils ont un bon score.<br/>
  <br/>👉 Un </span><span class="lato-bold">juste milieu</span><span class="lato-regular"> entre rigueur et ouverture.<br/>
  <br/><span class="lato-bold">Résultat :</span> Une synthèse harmonieuse, ni trop restrictive, ni trop large.</span></p>

  <p><span class="lato-bold">🔵 Mode Large</span></p>
  <p><span class="lato-regular">Tous les chevaux ayant obtenu un score suffisant peuvent être inclus, </span><span class="lato-bold">même s’ils ne figurent que dans un seul pronostic</span><span class="lato-regular">.<br/>
  <br/>👉 Idéal pour une approche </span><span class="lato-bold">exploratoire</span><span class="lato-regular">, permettant de </span><span class="lato-bold">ne passer à côté d’aucun outsider</span><span class="lato-regular">.<br/>
  <br/><span class="lato-bold">Résultat :</span> Une sélection plus étendue, adaptée aux stratégies ouvertes.</span></p>


  <p><span class="lato-bold">✅ Quel mode choisir ?</span></p>
  <ul>
    <li><span class="lato-regular"><span class="lato-bold">Strict</span> : Pour une stratégie courte et ciblée.</span></li>
    <li><span class="lato-regular"><span class="lato-bold">Équilibré</span> : Pour un bon compromis.</span></li>
    <li><span class="lato-regular"><span class="lato-bold">Large</span> : Pour maximiser les options et couvrir plus de chevaux.</span></li>
  </ul>
  </div>                  

                  }
                  />
                  )}

               <Box sx={{ width: '100vw', maxWidth: '100vw', height:'55px', maxHeight:'55px', bgcolor: 'white' , overflow:'hidden', overflowX:'hidden', borderBottomWidth:"5px", borderBottomColor:"grey", borderBottomStyle:"inset" }}>
               <Grid container spacing={1}>
               <Grid item xs={6}>
               <div style={{display:"flex"}}>
                  <div>
                    <img style={{marginTop:"0.2em", marginLeft:"1em"}} width='33' height={45} src={"https://dataturf.fr/images/logo_noir.png"}></img>
                  </div>
                  <div style={{marginTop:"0.7em"}}>
                      <span style={{fontFamily:"Racing Sans One", fontSize:"25px", marginLeft:"0.5em"}}>TROTSTATS</span> 
                      <span style={{fontFamily:"Racing Sans One", fontSize:"20px", marginLeft:"0.3em"}}>- SynthèseMax</span> 
                  </div>

                  <Divider style={{marginLeft:"1em"}} orientation="vertical" flexItem />

<div style={{marginTop:"0.7em"}}>

<Tooltip title={<span class="lato-regular">Menu</span>}>
<IconButton
  aria-label="close"
  style={{marginLeft:"1em"}}
  onClick={this.handleOpenMenu}
  aria-haspopup="true"
>
    <MenuIcon style={{color:"black"}} />
</IconButton>
</Tooltip>

<Menu
  id="basic-menu"
  open={this.state.openMenu}
  anchorEl={this.state.anchor}
  onClose={this.handleCloseMenu}
  MenuListProps={{
    'aria-labelledby': 'basic-button',
  }}
>
  

<MenuItem onClick={this.redirectTableau}>
                      <ListItemIcon>
                        <SpaceDashboardOutlinedIcon style={{color:"black"}} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText><span class="lato-regular">Tableau de bord</span></ListItemText>
                      
                    </MenuItem>

  <MenuItem onClick={this.redirectHome}>
    <ListItemIcon>
      <ArticleOutlinedIcon style={{color:"black"}} fontSize="small" />
    </ListItemIcon>
    <ListItemText><span class="lato-regular">Synthèses</span></ListItemText>
    <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
      ⌘F1
    </Typography>
  </MenuItem>
  
  <Divider/>

  <MenuItem  onClick={this.redirectPronostics}>
                        <ListItemIcon>
                          <TuneOutlinedIcon style={{color:"black"}} fontSize="small" />
                        </ListItemIcon>
                        <ListItemText><span class="lato-regular">Gestion des Pronostics</span></ListItemText>
                        <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
                          ⌘F2
                        </Typography>
                      </MenuItem>
  
  <MenuItem onClick={this.redirectEditeur}>
    <ListItemIcon>
      <ModeEditOutlinedIcon style={{color:"black"}} fontSize="small" />
    </ListItemIcon>
    <ListItemText><span class="lato-regular">Éditeur de Pronostics</span></ListItemText>
    <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
      ⌘F3
    </Typography>
  </MenuItem>
  <Divider/>

  <MenuItem disabled={this.isMobile ? true : false} onClick={this.handleCloseMenu} style={{cursor:"default", backgroundColor:"#E0E0E0"}}>
                      <ListItemIcon>
                        <AutoGraphOutlinedIcon style={{color:"black"}} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText><span class="lato-bold">Synthèse Max</span></ListItemText>
                      <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
                        
                      </Typography>
                    </MenuItem>
  
  <MenuItem onClick={this.redirectBibliotheque}>
                      <ListItemIcon>
                        <SmartToyOutlinedIcon style={{color:"black"}} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText><span class="lato-regular">AlgoProno Labs</span></ListItemText>
                      <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
                        
                      </Typography>
                    </MenuItem>

   <Divider/>
                                                            
                  <MenuItem onClick={this.redirectForum}>
                    <ListItemIcon>
                      <ForumOutlinedIcon style={{color:"black"}} fontSize="small" />
                       </ListItemIcon>
                       <ListItemText><span class="lato-regular">Forum</span></ListItemText>
                      <Typography variant="body2" sx={{ color: 'text.secondary', marginLeft:"2em" }}>
                    </Typography>
                 </MenuItem> 

</Menu>

<Tooltip title={<span class="lato-regular">Aide</span>}>
<IconButton
  style={{marginLeft:"1em"}}
  aria-label="close"
  onClick={this.activeAide}
>
<HelpOutlineOutlinedIcon style={{color:"black"}} />
</IconButton>
</Tooltip>

</div>

<Divider style={{marginLeft:"1em"}} orientation="vertical" flexItem />

<div style={{marginTop:"0.7em"}}>

                  <IconButton
                    disabled={this.state.syntheseMax == "O" ? false : true}
                    aria-label="close"
                    style={{marginLeft:"1em"}}
                    onClick={() => this.runTest()}
                  >
                  <Tooltip title={<span class="lato-regular">Lancer SynthèseMax</span>}>
                    <PlayCircleOutlinedIcon style={{color:this.state.syntheseMax == "O" ? "black" : "#D3D3D3"}} />
                  </Tooltip>
                  </IconButton>

                  <IconButton
                    disabled={this.state.syntheseMax == "O" ? false : true}
                    aria-label="close"
                    style={{marginLeft:"1em"}}
                    onClick={() => this.openDialogEnregistrer()}
                  >
                  <Tooltip title={<span class="lato-regular">Enregistrer</span>}>
                    <CloudUploadIcon style={{color:this.state.syntheseMax == "O" ? "black" : "#D3D3D3"}} />
                  </Tooltip>
                  </IconButton>



</div>


                </div>
                </Grid>
                <Grid item xs={6}>
                  <div style={{float:"right", margin:"0.5em"}}>
                 
                  <IconButton
                    aria-label="close"
                    style={{marginLeft:"1em"}}
                    onClick={this.redirectHome}
                  >
                    <Tooltip title={<span class="lato-regular">Retour synthèse</span>}>
                  <CloseIcon style={{color:"black"}} />
                  </Tooltip>
                  </IconButton>
                </div>
                </Grid>
                
                </Grid>
               </Box>
            
            
            <div style={{display:'flex'}}>
            
            <Box sx={{ width: this.state.taillePanelFiltre, maxWidth: this.state.taillePanelFiltre, height:'calc(100vh - 60px)', maxHeight:'calc(100vh - 60px)', bgcolor: '#FAFAFA' , overflow:'scroll', overflowX:'hidden' }}>
              <div style={{margin:"1em"}}>
                <FiltrePronosticsSynthese filtres={this.filtres}/>
              </div>
             
             
            </Box>

            <Box sx={{ width: this.state.taillePanel, maxWidth: this.state.taillePanel, height:'calc(100vh - 60px)', maxHeight:'calc(100vh - 60px)', bgcolor: 'white', overflow:'hidden', overflowX:'hidden' }}>

            <div>
                <Box sx={{ width: this.state.taillePanel, maxWidth: this.state.taillePanel, height:'calc(100vh - 60px)', maxHeight:'calc(100vh - 60px)', bgcolor: '#FAFAFA', overflow:'scroll', overflowX:'hidden' }}>
                
                <div style={{margin:"1em"}}>
        <div style={{marginTop:"1em", marginBottom:"2em"}}>
        <center>
          <span class="lato-bold" style={{fontVariant:"small-caps", fontSize:"17px"}}>paramétrage de la synthèse</span>
          <div style={{float:"right"}}>
          <IconButton onClick={() => this.resize()} aria-label="delete">
            {this.state.zoom && (
               <FullscreenExitOutlinedIcon style={{color:"black"}}/>
            )}
            {!this.state.zoom && (
              <FullscreenOutlinedIcon style={{color:"black"}}/> 
            )}
          </IconButton>
          </div>
          <div style={{marginTop:"1em", width:"70%"}}>
            <Divider/>
          </div>
        </center>
        </div>

        {(this.state.syntheseMax == "N" && (
                                      <div>
                                        
                                        <Alert style={{ marginBottom: "1em" }} severity="info">
          <span style={{ fontSize: "14px" }} className="lato-regular">
          <b>Synthèse Max</b> est un module optionnel de Trotstats qui vous permet de créer vos propres synthèses personnalisées à partir de vos pronostics. 
          
          <br/><br/>
          <b>Fusionnez différents pronostics</b>, combinez vos sources préférées et testez le tout sur les courses passées pour en évaluer la performance réelle.
          <br/><br/>
          Grâce à son moteur d’analyse, <b>Synthèse Max</b> vous fournit des statistiques détaillées sur l’<b>efficacité de votre synthèse</b>.
          <br/><br/>
          Vous pouvez également <b>exporter l’historique complet</b> de votre synthèse sous <b>format Excel</b>.
            <br /><br />
            🔓 Débloquez l'accès dès maintenant !  
            <br/><br/>
           
            👉
            <a href="https://www.paypal.com/ncp/payment/GPDF6Y786VRB6" target="_blank" style={{ color: "blue", textDecoration: "underline", fontWeight: "bold" }}>  
              lien vers le paiement 
            </a>
            <br/><br/>
            <i>
            En achetant ce module, vous bénéficiez d'un accès à vie, sans frais récurrents. Aucune nécessité de paiement mensuel, c'est un achat unique.
            </i>
          </span>
        </Alert>
                                        
                                      </div>
                                    ))}


        <div>
          <Card>
          <CardHeader
          action={
                    <div>
                   
                        <HelpOutlineOutlinedIcon onClick={this.openAideConsensus}  style={{color:"black", margin:"0.3em", cursor:"pointer"}}/>
                   
                   
                    </div>
                    }
           title={<div><span class="lato-bold" style={{transform:"none", fontSize:"14px", textTransform:"none"}}>Mode de Consensus</span></div>}
          />
          <FormControl style={{ marginLeft:"1em", marginBottom:"1em", width:"250px"}}>
                  <InputLabel id="demo-simple-select-label"><span style={{color:"black"}} class="lato-regular">Consensus</span></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.consensus}
                    label="Consensus"
                    defaultValue={"equilibre"}
                    onChange={this.handleConsensus}
                  >
                  <MenuItem value={"strict"}><span class="lato-regular" style={{fontSize:"14px"}}>Mode Strict</span></MenuItem>
                  <MenuItem value={"majoritaire"}><span class="lato-regular" style={{fontSize:"14px"}}>Mode Majoritaire</span></MenuItem>
                  <MenuItem value={"equilibre"}><span class="lato-regular" style={{fontSize:"14px"}}>Mode Équilibré</span></MenuItem>
                  <MenuItem value={"large"}><span class="lato-regular" style={{fontSize:"14px"}}>Mode Large</span></MenuItem>
                  
                  </Select>
        </FormControl>
          </Card>
        </div>

        {this.state.pronostics != null && this.state.pronostics.length > 0 && (

          <div style={{marginTop:"1em"}}>
          <Card>
          <CardHeader
          
          title={<div><span class="lato-bold" style={{transform:"none", fontSize:"14px", textTransform:"none"}}>Tableau des pronostics</span> <span style={{transform:"none", fontSize:"13px", textTransform:"none"}} class="lato-regular-italic">{this.state.pronostics.length} résultat(s)</span></div>}
          
         />
            <TableauPronosticsSynthese syntheseMax={this.state.syntheseMax} data={this.state.pronostics} updatePoint={this.updatePoint} delete={this.deletePronostics} actif={this.updateActif} obligatoire={this.updateObligatoire} update={this.callPronostics} select={this.select}  />
          </Card>


          </div>
        )}

         {this.state.pronostics == null || this.state.pronostics.length == 0 && (
          <div style={{marginTop:"1em"}}>
          <Alert severity="info">
          <AlertTitle><span class="lato-regular" style={{transform:"none", fontSize:"14px", textTransform:"none"}}>Information</span></AlertTitle>
          <span class="lato-regular" style={{transform:"none", fontSize:"14px", textTransform:"none"}}>Aucun pronostic trouvé. <br/>
          Utilisez l’éditeur pour créer vos premiers pronostics et démarrer votre analyse.
          </span>
          </Alert>
          </div>
         )}

          {this.state.bilan != null && (
            <div style={{marginTop:"2em"}}>
            <center>
              <span class="lato-bold" style={{fontVariant:"small-caps", fontSize:"17px"}}>résultat de la synthèse</span>
              <div style={{marginTop:"1em", width:"70%"}}>
                <Divider/>
              </div>
            </center>

<Table style={{marginTop:"2em"}} component={Paper}>
          <TableHead>
            <TableRow>
              <TableCell><span class="lato-bold">Performance de la synthèse (3 dern. mois)</span></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Nombre de synthèse :</span></TableCell>
                <TableCell width={"100%"} align="right" ><span class="lato-regular">{selection(this.state.bilan.nombreSynthese)}</span></TableCell>
              </TableRow>
              
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses avec le gagnant :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteSyntheseGagnant)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses avec un cheval dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteSynthesePlace)}</span></TableCell>
              </TableRow>
              
          </TableBody>
        </Table>

        <Accordion style={{marginTop:"2em"}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span"><span class="lato-bold">+ d'informations
                          </span></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Table component={Paper}>
          <TableHead>
            <TableRow>
              <TableCell><span class="lato-bold">Performance de la synthèse (3 dern. mois)</span></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de réussite du cheval en tête vainqueur :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteChevalTeteGagnant)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de réussite du cheval en tête dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteChevalTetePlace)}</span></TableCell>
              </TableRow>
             
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses avec 2 chevaux dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteSynthese2Place)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses avec 3 chevaux dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussiteSynthese3Place)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses (en trois chevaux) avec le gagnant :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussite3Gagnant)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses (en trois chevaux) avec un cheval dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussite3Place)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses (en trois chevaux) avec 2 chevaux dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussite3Place2)}</span></TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={"100%"} align="left"><span class="lato-regular">Taux de synthèses (en trois chevaux) avec 3 chevaux dans le Top 3 :</span></TableCell>
                <TableCell width={"100%"} align="right"><span class="lato-regular">{reussite(this.state.bilan.reussite3Place3)}</span></TableCell>
              </TableRow>
            
          </TableBody>
        </Table>
                        </AccordionDetails>
                      </Accordion>


<div style={{marginTop:"2em"}}>
<center>
              <span class="lato-bold" style={{fontVariant:"small-caps", fontSize:"17px"}}>dernières synthèses</span>
              <div style={{marginTop:"1em", width:"70%"}}>
                <Divider/>
              </div>
            </center>
        </div>
        <Table style={{marginTop:"2em"}} component={Paper}>
                    
          <TableRow>
            <TableCell width={"100px"}><span class="lato-bold">Date</span></TableCell>
            <TableCell width={"200px"}><span class="lato-bold">Hippodrome</span></TableCell>
            <TableCell width={"70px"}><span class="lato-bold">Course</span></TableCell>
            <TableCell width={"400px"}><span class="lato-bold">Synthèse</span></TableCell>
            <TableCell width={"400px"}><span class="lato-bold">Arrivée</span></TableCell>
          </TableRow>
       
          
          {this.state.bilan != null && this.state.bilan.syntheses != null && this.state.bilan.syntheses.map((synthese) => (
            <TableRow>
            <TableCell>
              <span class="lato-regular">{synthese.date}</span>
            </TableCell>
            <TableCell>
              <span class="lato-regular" style={{fontSize:"13px"}}>{synthese.hippodrome}</span>
            </TableCell>
            <TableCell>
              <span class="lato-regular">C{synthese.numCourse}</span>
            </TableCell>
            <TableCell>
            <div style={{display:"flex"}}>
                {synthese.synthese.syntheseParPoints[0] != null && (
                      <div style={{marginLeft:"1em"}}>
                        <Badge badgeContent={(synthese.synthese.syntheseParPoints[0].points)} color="primary">
                         <Avatar sx={{cursor:"pointer", bgcolor: "#66B230"}} >{synthese.synthese.syntheseParPoints[0].num}</Avatar>
                        </Badge>
                      </div>
                    )}

                {synthese.synthese.syntheseParPoints[1] != null && (
                      <div style={{marginLeft:"1em"}}>
                        <Badge badgeContent={Number(synthese.synthese.syntheseParPoints[1].points)} color="primary">
                         <Avatar sx={{cursor:"pointer", bgcolor: "#FF8F60"}} >{synthese.synthese.syntheseParPoints[1].num}</Avatar>
                        </Badge>
                      </div>
                    )}

                {synthese.synthese.syntheseParPoints[2] != null && (
                      <div style={{marginLeft:"1em"}}>
                        <Badge badgeContent={Number(synthese.synthese.syntheseParPoints[2].points)} color="primary">
                         <Avatar sx={{cursor:"pointer", bgcolor: "#FFAA16"}} >{synthese.synthese.syntheseParPoints[2].num}</Avatar>
                        </Badge>
                      </div>
                    )}

                {synthese.synthese.syntheseParPoints[3] != null && (
                      <div style={{marginLeft:"1em"}}>
                        <Badge badgeContent={Number(synthese.synthese.syntheseParPoints[3].points)} color="primary">
                         <Avatar sx={{cursor:"pointer", bgcolor: "#5B86F2"}} >{synthese.synthese.syntheseParPoints[3].num}</Avatar>
                        </Badge>
                      </div>
                    )}

                {synthese.synthese.syntheseParPoints[4] != null && (
                      <div style={{marginLeft:"1em"}}>
                        <Badge badgeContent={Number(synthese.synthese.syntheseParPoints[4].points)} color="primary">
                         <Avatar sx={{cursor:"pointer", bgcolor: "#B491FF"}} >{synthese.synthese.syntheseParPoints[4].num}</Avatar>
                        </Badge>
                      </div>
                    )}
              </div>

            </TableCell>
            <TableCell>

            <div style={{display:"flex"}}>
                  {synthese.classement
                    .split("-")
                    .slice(0, 5) 
                    .map((item, index) => (
                    <Avatar sx={{cursor:"pointer", marginRight:"0.5em", bgcolor: color(item, synthese.synthese.syntheseParPoints[0] != null ? synthese.synthese.syntheseParPoints[0].num : "", synthese.synthese.syntheseParPoints[1] != null ? synthese.synthese.syntheseParPoints[1].num : "", synthese.synthese.syntheseParPoints[2] != null ? synthese.synthese.syntheseParPoints[2].num : "", synthese.synthese.syntheseParPoints[3] != null ? synthese.synthese.syntheseParPoints[3].num : "", synthese.synthese.syntheseParPoints[4] != null ? synthese.synthese.syntheseParPoints[4].num : "")}}>{item}</Avatar>
                  ))}
                  </div>

            </TableCell>
            </TableRow>
          ))}

           
        </Table> 
          
            <Button  fullWidth style={{marginTop:"1em", marginBottom:"3em"}} variant="outlined" startIcon={ <CloudDownloadOutlinedIcon  />}  onClick={() => {this.handleDownload('', 'syntheseMax_export.xls')}}>
              <span class="lato-regular">Export Complet</span>
            </Button>
            

            </div>
           
          )}


        </div>

                  
                
                    
                </Box>
            </div>
                
            </Box>

            </div>



            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={this.state.loader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>

            
            <DialogResultat data={this.state.result} open={this.state.openDialog} closeDialog={this.closeDialog} />
            
            <Dialog
              open={this.state.openDialogEnregistrer}
              onClose={this.closeDialogEnregistrer}
              fullWidth
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
               {<span class="lato-bold">Enregistrer</span>}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={this.closeDialogEnregistrer}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
              <CloseIcon style={{color:"black"}} />
              </IconButton>
              <Divider/>
              <DialogContent>
                <span class="lato-regular">Voulez-vous enregistrer cette configuration pour {syn(this.dossier)} ?</span>
                <br/><br/>
                <span class="lato-regular">Type de Consensus : {consu(this.state.consensus)}</span><br/>
                <span class="lato-regular">Paramétrage des pronostics : <span class="lato-regular-italic"><b>Tel que défini</b></span></span>
              </DialogContent>
              <Divider/>
              <DialogActions>

              <IconButton
                    aria-label="close"
                    style={{marginLeft:"1em"}}
                    onClick={this.save}
                  >
                  <CheckOutlinedIcon style={{color:"black"}} />
                  </IconButton>
              </DialogActions>
            </Dialog>


            <Dialog
              open={this.state.openPoint}
              onClose={this.closeOpenPoint}
              fullWidth
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
               {<span class="lato-bold">Points</span>}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={this.closeOpenPoint}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
              <CloseIcon style={{color:"black"}} />
              </IconButton>
              <Divider/>
              <DialogContent>
                <span class="lato-regular">Personnaliser les points accordés aux chevaux dans le pronostic.</span>
                
                <FormControl fullWidth style={{marginTop:"2em", marginBottom:"1em"}}>
                  <InputLabel id="demo-simple-select-label"><span style={{color:"black"}} class="lato-regular">Bonus / Malus (points)</span></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.point}
                    label="Bonus / Malus (points)"
                    defaultValue={"1"}
                    onChange={this.handleSelectPoint}
                  >
                  <MenuItem value={"-5"}><span class="lato-regular" style={{fontSize:"14px", color : "#C53419"}}>- 5 point  (Malus)</span></MenuItem>
                  <MenuItem value={"-4"}><span class="lato-regular" style={{fontSize:"14px", color : "#C53419"}}>- 4 points (Malus)</span></MenuItem>
                  <MenuItem value={"-3"}><span class="lato-regular" style={{fontSize:"14px", color : "#C53419"}}>- 3 points (Malus)</span></MenuItem>
                  <MenuItem value={"-2"}><span class="lato-regular" style={{fontSize:"14px", color : "#D57B1A"}}>- 2 points (Malus)</span></MenuItem>
                  <MenuItem value={"-1"}><span class="lato-regular" style={{fontSize:"14px", color : "#D57B1A"}}>- 1 point  (Malus)</span></MenuItem>
                  <MenuItem value={"1"}><span class="lato-regular" style={{fontSize:"14px", color:"#97BA38"}}>+ 1 point  (Bonus)</span></MenuItem>
                  <MenuItem value={"2"}><span class="lato-regular" style={{fontSize:"14px", color:"#97BA38"}}>+ 2 points (Bonus)</span></MenuItem>
                  <MenuItem value={"3"}><span class="lato-regular" style={{fontSize:"14px", color:"#2D7E43"}}>+ 3 points (Bonus)</span></MenuItem>
                  <MenuItem value={"4"}><span class="lato-regular" style={{fontSize:"14px", color:"#2D7E43"}}>+ 4 points (Bonus)</span></MenuItem>
                  <MenuItem value={"5"}><span class="lato-regular" style={{fontSize:"14px", color:"#2D7E43"}}>+ 5 points (Bonus)</span></MenuItem>
                  
                  </Select>
                  <span class="lato-regular-italic" style={{fontSize:"13px"}}>Utilisez le bonus / malus pour attribuer les points aux chevaux du pronostics.</span>
                </FormControl>
               
              </DialogContent>
              <Divider/>
              <DialogActions>

              <IconButton
                    aria-label="close"
                    style={{marginLeft:"1em"}}
                    onClick={this.savePoint}
                  >
                  <CheckOutlinedIcon style={{color:"black"}} />
                  </IconButton>

                
               
              </DialogActions>
            </Dialog>


            </div>

        )
    }
}